import _get from 'lodash/get';
import type { UpdateWeddingRequest, WWeddingView } from '@zola/svc-web-api-ts-client';

export type WeddingType = UpdateWeddingRequest & WWeddingView;
export interface WeddingState {
  wedding: WeddingType;
}
export interface RootState {
  wedding: WeddingState;
}

export const getWedding = (state: RootState): WWeddingView => _get(state, 'wedding.wedding', {});

export default getWedding;



// WEBPACK FOOTER //
// ./src/selectors/wedding/index.ts